export default "__VITE_ASSET__BoTQKdSv__"